import { Module } from "wrapper6";
import ImageCompare from "image-compare-viewer";

var $ = jQuery;

export default class ComparisonWidget extends Module {

  ready(app) {
    const elements = document.querySelectorAll('.mtt-before-after-image-widget__image-comparison')
    if (elements.length > 0) {
      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        const myViewer = new ImageCompare(element, {
          addCircle: true,
          addCircleBlur: false,
          controlColor: '#ffffff',
          controlShadow: false,
          showLabels: true,
          labelOptions: {
            before: 'FØR',
            after: 'EFTER',
            onHover: false // default
          }
        }).mount()
      }
    }
  }
}